module.exports = "/images/TheGameTheroists_76492f.jpg";